"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVersionStatus = exports.VERSION_STATUS = void 0;
exports.VERSION_STATUS = {
    UNDEFINED: { displayName: 'Undefined', value: 0 },
    DRAFT: { displayName: 'Draft', value: 1 },
    REVIEW: { displayName: 'Review', value: 2 },
    SHARED: { displayName: 'Shared', value: 3 },
    PUBLISH: { displayName: 'Publish', value: 4 },
    ARCHIVED: { displayName: 'Archived', value: 5 },
    APPROVAL_REQUESTED: { displayName: 'For Approval', value: 6 },
    APPROVAL_REJECTED: { displayName: 'Approval Rejected', value: 7 },
    APPROVED: { displayName: 'Approved', value: 8 },
};
var getVersionStatus = function (versionStatus) {
    return Object.values(exports.VERSION_STATUS).find(function (status) { return status.value === versionStatus; }).displayName;
};
exports.getVersionStatus = getVersionStatus;
